// extracted by mini-css-extract-plugin
export default {"wrapper":"Skeleton_wrapper__GXLXQ","shimmer":"Skeleton_shimmer__Jmsk0"};